<template>
  <div class="error">
    <p>{{ error }}</p>
  </div>
</template>

<script>
export default {
  name: "ErrorPage",

  props: {
    error: {
      required: true,
      type: String,
    },
  },
}
</script>

<style scoped>
  .error {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
  }
</style>
